/* eslint-disable max-len */
import React from 'react'
import SearchShimmer from '../../../../../components/Shimmer/SearchShimmer';

export default function GroupsDropDown({
    outsideClickRef,
    getListOfGroup,
    setSearchValue,
    setIsSelectDropdown,
    isSelectDropdown,
    recodes,
    loadingSearch,
    groupList,
    handelCheckboxType,
    setSelectedGroupType,
    setIsSchemeGroup,
    searchValue,
    selectedGroupType,
    exitVal
}) {
    return (
        <div class="relative w-full profit_and_loss_dropdown" ref={outsideClickRef} data-te-dropdown-ref="">
            <button
                class={`slct-inpt-fld ${(exitVal && recodes.parent_group.parent_group_id === "") ? "redBorder" : "border-[#D0D5DD]"} transition duration-150 ease-in-out more-lines`}
                type="button" id="group_dropdown"
                onClick={()=> {getListOfGroup(); setIsSelectDropdown(!isSelectDropdown)}}
                title={recodes?.parent_group?.parent_group_name}
            >
                <p class={`text-f7 more-lines ${ recodes?.parent_group?.parent_group_name === "" ? "text-[#818E98]" : "text-[#344054] "} font-normal`}>
                    {recodes?.parent_group?.parent_group_name === "" ? recodes?.type === "group" ? "Select Parent Group" : "Select Group Name" : recodes?.parent_group?.parent_group_name }
                </p>
                <img loading="lazy" src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${isSelectDropdown? "transform rotate-180" : ""}`}/>
            </button>
            {(isSelectDropdown && (
                <ul class={`slct_drp_dwn min-w-full
                ${((selectedGroupType !== "Sundry Creditors" && selectedGroupType !== "Bank OD Account" && selectedGroupType !== "Bank Accounts") || recodes.type === "group") ? 'min-w-[172%]' : "min-w-[172%]"}
                 [&amp;[data-te-dropdown-show]]:block`} 
                >
                    <li>
                        <div class="relative w-full">
                            <label for="input"></label>
                            <input 
                                type="text" 
                                value={searchValue}
                                onChange={(e) => {setSearchValue(e.target.value)
                                    getListOfGroup(e.target.value)}}
                                class="slct-inpt-fld" 
                                style={{'margin':'3px','width':'97.5%'}}
                                placeholder="Search" 
                                id='ledgers_dropdown_search'
                            />
                            <button class="absolute top-[50%] -translate-y-[50%] right-2">
                                <img 
                                    loading="lazy"
                                    decoding="async"
                                    src="/images/search.svg"
                                    alt="img"
                                    class="w-[16px] h-[18px]"
                                    onClick={() => {setSearchValue(searchValue)
                                        getListOfGroup(searchValue)}}
                                />
                            </button>
                        </div>
                    </li>
                    {loadingSearch ? 
                        <div class="pl-2 pt-1"><SearchShimmer height={'145px'}/></div> :
                        (<><li>
                            <ul class="max-h-[150px] overflow-auto scroll-bar mt-1">
                                {groupList?.length > 0 ? groupList.map((item) => (
                                    <li key={item._id}>
                                        <p
                                            onClick={() => {
                                                handelCheckboxType(item.group_type, "group_type");
                                                handelCheckboxType({"parent_group_id": item.parent_group_id_composite_key, "parent_group_name" : item.parent_group_name_composite_key }, "parent_group", item.associated_position);
                                                setSelectedGroupType(item.parent_group_type);
                                                setIsSchemeGroup(item.is_scheme_group);
                                                if(item.parent_group_type === "Bank OD Account") {
                                                    handelCheckboxType("OD Account", "account_type");   
                                                } else {
                                                    handelCheckboxType("", "account_type");   
                                                }
                                                setIsSelectDropdown(false)
                                            }} 
                                            class="slct_drp_dwn_optn">
                                            {item.parent_group_name_composite_key}
                                        </p>
                                    </li> ))
                                    :<li>
                                        <p
                                            class="slct_drp_dwn_optn" href="#" data-te-dropdown-item-ref="">
                                            Search result not found.
                                        </p>
                                    </li>
                                }
                            </ul>
                        </li></>)}
                </ul>))}
        </div>
    )
}
